export default __webpack_public_path__ + "static/media/diamond.03426d44.png";